import BadgeStatus from 'src/components/BadgeStatus/BadgeStatus.component';
import { ListRequestsResultsTable } from 'src/pages/AdvPaymentFlow/AdvPaymentFlow.types';
import {
  AdvPlanRequestsStatus,
  AdvPlanRequestsStatusMap,
} from 'src/pages/advancePlanRequests/AdvancePlanRequests.config';
import React from 'react';

const StatusColumn: React.FC<ListRequestsResultsTable> = ({ Status }) => {
  return (
    <BadgeStatus
      {...AdvPlanRequestsStatusMap[Number(Status) as AdvPlanRequestsStatus]}
    />
  );
};

export default StatusColumn;
